// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3134":"82da04af559eba6d","9168":"4a3e686926436ff2"}[chunkId] + ".css";
};